
  import { Component, Prop } from 'vue-property-decorator';
  import { mixins } from 'vue-class-component';
  import SidebarPanelMixin from '@/mixins/SidebarPanel';

  @Component({
    components: {},
  })
  export default class SidebarPanel extends mixins(SidebarPanelMixin) {
    @Prop({ required: true }) readonly header!: string;

    @Prop({ required: true }) readonly headerIcon!: string;

    get headerTextClasses() {
      return this.isInSidebar ? [] : ['d-none', 'd-md-inline-block'];
    }

    clickedHeader(event: Event) {
      event.stopPropagation();
      if (!this.isInSidebar) {
        this.$vxm.mobile.showPageSidebar = true;
      }
    }

    get headerStyle() {
      return { 'flex-direction': this.isInSidebar ? 'row' : 'row-reverse' };
    }
  }
